export function noOp() { }



// WEBPACK FOOTER //
// ./src/app/services/utils/noop.ts